export default __webpack_public_path__ + "static/media/icon pix color.40f9af8e.png";